module.exports = __webpack_public_path__ + "img/mobi-offline.bdeb98f7.png";